import unfiLogo from "/img/integration/unfi.png"
import { ConnectMailboxButtons } from "@/connect_mailbox/connect_mailbox_buttons"
import { ConnectLogo } from "../connect-logo"
import { Button } from "@/components/ui/button.tsx"
import { useAsyncEffect } from "@/utils"
import { DateTime } from "luxon"
import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import {
  getIntegrations,
  upsertIntegration,
  IntegrationWithJobInfo,
} from "@/api/integration"
import { EmailSelector } from "@/setup/config/email-config-page"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectUnfiPage(props: any = {}) {
  const redirectTo: string = props.redirectTo ?? "/setup/config/unfi"
  const [emails, setEmails] = useState<IntegrationWithJobInfo[]>([])
  const [existingUnfi, setExistingUnfi] = useState<IntegrationWithJobInfo | null>(null)
  const [selectedEmail, setSelectedEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [, setLocation] = useLocation()

  const currentPath = window.location.pathname

  async function reloadEmails() {
    const res = await getIntegrations()
    if (!res.ok) {
      console.error(res.error)
      return
    }
    const emailAccounts = res.value.data.filter((i: IntegrationWithJobInfo) => ["gmail", "microsoft"].includes(i.name))
    setEmails(emailAccounts)
    setExistingUnfi(res.value.data.find((i: IntegrationWithJobInfo) => i.name === "unfi") ?? null)
    if (emailAccounts.length === 1) {
      setSelectedEmail(emailAccounts[0].username)
    }
  }

  useAsyncEffect(reloadEmails, [])

  async function handleContinue() {
    if (!selectedEmail) return
    setLoading(true)
    // Reuse the existing UNFI integration when re-connecting an email so its saved configuration
    // (portal credentials, vendor name, remit number, etc.) is preserved.
    let integration_id = existingUnfi?.id
    if (!integration_id) {
      // Create the UNFI integration with empty username; email goes into data.email_address
      const res = await upsertIntegration("unfi", "", {})
      if (!res.ok) {
        setLoading(false)
        console.error(res.error)
        return
      }
      integration_id = res.value.data.id
    }
    // Set the email_address in the integration data
    const { updateIntegration } = await import("@/api/integration")
    const updateRes = await updateIntegration(integration_id, {
      data: { email_address: selectedEmail },
    })
    setLoading(false)
    if (!updateRes.ok) {
      console.error(updateRes.error)
      return
    }
    setLocation(redirectTo)
  }

  return (
    <CenterColumnContainer>
      <div class="space-y-6">
        <ConnectLogo src={unfiLogo} alt="UNFI" />
        <p class="text-gray-500 text-sm">
          UNFI sends deduction and dispute information via email. Connect the email account that receives UNFI
          communications, then select it below.
        </p>

        <ConnectMailboxButtons microsoftLabel="Connect Microsoft Office 365" onChange={reloadEmails} />

        {emails.length > 0 && (
          <EmailSelector
            emailAccounts={emails}
            selectedEmail={selectedEmail}
            onSelect={setSelectedEmail}
            description="Select which email account receives UNFI communications."
          />
        )}

        <Button className="w-full" onClick={handleContinue} disabled={!selectedEmail || loading}>
          {loading ? "Creating..." : "Continue"}
        </Button>

        {emails.length === 0 && (
          <p class="text-sm text-gray-400 text-center">Connect at least one email account to continue</p>
        )}
      </div>
    </CenterColumnContainer>
  )
}
